interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: (value: string) => void;
  placeholder?: string;
  submitLabel?: string;
}

export default function SearchInput({
  value,
  onChange,
  onSubmit,
  placeholder = '검색하기',
  submitLabel = '선택',
}: SearchInputProps) {
  const trimmed = value.trim();

  const submit = () => {
    if (!trimmed) return;
    onSubmit?.(trimmed);
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit();
        }}
        placeholder={placeholder}
        className="w-full pl-10 pr-16 py-3 bg-white rounded-xl text-sm text-navy placeholder:text-beige-dark border border-cream-dark focus:border-navy focus:outline-none transition-colors"
      />
      <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-navy-light">
        <i className="ri-search-line" />
      </div>
      {trimmed && onSubmit && (
        <button
          type="button"
          onClick={submit}
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-navy text-white text-xs font-medium px-3 py-1.5 rounded-lg cursor-pointer"
        >
          {submitLabel}
        </button>
      )}
    </div>
  );
}
